import React, { useState } from "react";
import { documentSlotAppearance } from "../model/complianceRules";
import DocumentRow from "./DocumentRow";
import { slotStyles as styles } from "./complianceStyles";

function LinkForm({ busy, linkValue, onChange, onSubmit }) {
    const hasLink = Boolean(linkValue.trim());
    return (
        <div style={styles.linkForm}>
            <input
                type="url"
                value={linkValue}
                onChange={event => onChange(event.target.value)}
                onKeyDown={event => {
                    if (event.key === "Enter") onSubmit();
                }}
                placeholder="https://..."
                style={styles.linkInput}
            />
            <button
                type="button"
                disabled={busy || !hasLink}
                onClick={onSubmit}
                style={styles.linkConfirm(hasLink, busy || !hasLink)}
            >
                OK
            </button>
        </div>
    );
}

function SlotActions({ busy, onUpload, onAddLink }) {
    const [linkValue, setLinkValue] = useState("");
    const [linkOpen, setLinkOpen] = useState(false);
    const submitLink = () => {
        const trimmed = linkValue.trim();
        if (!trimmed) return;
        onAddLink(trimmed);
        setLinkValue("");
        setLinkOpen(false);
    };

    return (
        <div style={styles.actionsColumn}>
            <div style={styles.actionsRow}>
                <label style={styles.importLabel(busy)}>
                    Importer
                    <input
                        type="file"
                        multiple
                        disabled={busy}
                        onChange={event => {
                            onUpload(event.target.files);
                            event.target.value = "";
                        }}
                        style={styles.hidden}
                    />
                </label>
                <button type="button" disabled={busy} onClick={() => setLinkOpen(open => !open)} style={styles.linkToggle(busy)}>
                    Entrer un lien
                </button>
            </div>
            {linkOpen && <LinkForm busy={busy} linkValue={linkValue} onChange={setLinkValue} onSubmit={submitLink} />}
        </div>
    );
}

export default function DocumentSlot({ title, documents, busy, onUpload, onAddLink, onOpen, onDelete, onRename, additional = false }) {
    const appearance = documentSlotAppearance(documents.length, additional);

    return (
        <div style={styles.slot(appearance)}>
            <div aria-label={appearance.statusLabel} title={appearance.statusLabel} style={styles.indicator(appearance)}>
                ✓
            </div>
            <div style={styles.column}>
                <div style={styles.title}>
                    {title}
                </div>
                <div style={styles.summary(appearance.summaryColor)}>
                    {appearance.summary}
                </div>
            </div>
            <div style={styles.column}>
                {documents.length > 0 ? (
                    <div style={styles.documentList}>
                        {documents.map(document => (
                            <DocumentRow
                                key={document.id}
                                document={document}
                                busy={busy}
                                onOpen={onOpen}
                                onDelete={onDelete}
                                onRename={onRename}
                            />
                        ))}
                    </div>
                ) : (
                    <div style={styles.empty}>Aucun fichier</div>
                )}
            </div>
            <SlotActions busy={busy} onUpload={onUpload} onAddLink={onAddLink} />
        </div>
    );
}
